module.exports = __webpack_public_path__ + "img/20_114.8d9f9b1a.png";